import { useI18n } from "@core/i18n/i18n";
import { useFormatPatients } from "@domain/patient/hooks/use-patients";
import { PendingPatient } from "@domain/patient/patient";
import styled from "@emotion/styled";
import { stack } from "@ui/style";
import React from "react";
import { CreateTemplateCard } from "@ui/pages/home/pending-patient-dialog/components/create-template-card";
import { ResendCodeButton } from "@ui/pages/home/components/resend-code-button";

interface RegistrationDetailsStepProps {
	pendingPatient: PendingPatient;
	onResend: () => void;
	onCreateNewTemplateRequest: () => void;
}

export const RegistrationDetailsStep: React.FC<RegistrationDetailsStepProps> = ({
	pendingPatient,
	onResend,
	onCreateNewTemplateRequest,
}) => {
	const { format } = useI18n();
	const { formatPatientName } = useFormatPatients();

	return (
		<Container>
			<p className="p-size-m">
				{format("home.pendingPatientDialog.registrationDetails.text", {
					patientFullName: formatPatientName(pendingPatient),
				})}
			</p>
			<ResendCodeButton onClick={onResend}></ResendCodeButton>

			<CreateTemplateCard onCreateNewTemplateRequest={onCreateNewTemplateRequest}></CreateTemplateCard>
		</Container>
	);
};

const Container = styled.div`
	margin-top: 8px;
	${stack("XS")}
`;
